import React, { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";
import { AlertTriangle, Info } from "lucide-react";

export function ComplianceFooter() {
  const [block, setBlock] = useState(null);
  useEffect(() => {
    api.get("/compliance", { params: { location: "footer" } }).then((r) => setBlock(r.data?.[0] || null)).catch(() => {});
  }, []);
  return (
    <footer className="mt-16 border-t border-slate-200 bg-slate-50" data-testid="compliance-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        <div className="flex items-start gap-3">
          <Info className="w-4 h-4 text-slate-400 mt-0.5 shrink-0" />
          <p className="text-xs leading-relaxed text-slate-500">
            {block?.body ||
              "Educational content only · No guaranteed income · Results vary · You can lose money · Not legal, tax or financial advice."}
          </p>
        </div>
        <p className="text-xs text-slate-400 mt-4">© 2026 The High-Ticket Store Blueprint. Quiet Grove Sauna Co. is a fictional teaching example.</p>
      </div>
    </footer>
  );
}

export function ComplianceCallout({ block, testId = "compliance-block" }) {
  if (!block) return null;
  return (
    <div className="rounded-xl border border-slate-200 bg-slate-100 p-4" data-testid={testId}>
      <p className="text-xs font-semibold uppercase tracking-[0.15em] text-slate-500 mb-1.5">{block.title}</p>
      <p className="text-sm leading-relaxed text-slate-600">{block.body}</p>
    </div>
  );
}

export function WarningBanner({ messages, testId = "skipped-step-warning-banner" }) {
  if (!messages || messages.length === 0) return null;
  return (
    <div
      className="rounded-xl border border-amber-300 bg-amber-50 p-4 flex items-start gap-3"
      data-testid={testId}
    >
      <AlertTriangle className="w-5 h-5 text-amber-700 mt-0.5 shrink-0" />
      <div className="space-y-1">
        {messages.map((m, i) => (
          <p key={i} className="text-sm text-amber-900 leading-relaxed">
            {m}
          </p>
        ))}
      </div>
    </div>
  );
}
